<template>
  <div class="t-tabs">
    <div v-if="mobileState"
        class="t-input t-load-progress _mobile"
        :class="{'_loading': startLoading!=''}">
      <v-select :value="select.value"
                :options="select.options"
                :searchable="false"
                :filterable="false" @input="Change($event)"></v-select>
    </div>

    <template v-else>
      <router-link v-for="(link, index) in data" :key="index" 
          :to="{name: link.url}" 
          class=" t-load-progress"
          :class="{'_active': link.url === $route.name, '_loading': link.url === startLoading}"
          @click.native="SetStart( link.url )">{{ link.title }}</router-link>
    </template>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
      props: ['data'],
      data() {
        return {
          startLoading: ''
        }
      },
      computed: {
          ...mapGetters(['mobileState']),
          select() {
              let select = {
                  value: {},
                  options: []
              };

              for(let i = 0; i < this.data.length; i++){
                  select.options.push({
                      label: this.data[i].title,
                      value: this.data[i].url
                  });
                  if(this.data[i].url === this.$route.name){
                      select.value = {
                          label: this.data[i].title,
                          value: this.data[i].url
                      }
                  }
              }

              return select
          }
      },
      watch: {
        $route(newRoute, oldRoute){
          this.startLoading = ''
          this.$emit('Loading', false)
        }
      },
      methods: {
          Change(e){
              if(e.value !== this.$route.name){
                  this.startLoading = e.value
                  this.select.value = e
                  this.$emit('Loading', true)
                  this.$router.push({name: e.value})
              }
          },
          SetStart(url){
            if (this.$route.name != url){
              this.startLoading = url;
              this.$emit('Loading', true)
            }
          }
      }
  }
</script>

<style lang="sass">
@media(min-width: 770px)
  .t-tabs
    a:hover
      color: $blue
.t-tabs
  margin: 0 0 24px
  display: flex
  flex-wrap: wrap
  width: 100%
  border-bottom: 1px solid $disabled
  align-items: center
  justify-content: flex-start
  a
    padding: 0 16px 16px
    margin-bottom: -1px
    font-weight: bold
    color: $border
    transition: color .2s
    position: relative
    &:after
      content: ''
      position: absolute
      bottom: 0
      left: 0
      right: 0
      height: 3px
      width: 0
      border-radius: 2px
      background: transparent
      transition: background .2s

.t-load-progress
    &:after
      content: ''
      position: absolute
      left: 0
      right: 0
      height: 3px
      width: 0
      border-radius: 2px
      background: $blue
    &._mobile
      &:after
        top: calc(100% + 8px)
    &._loading
      &:after
        transition: background .2s, width 5s linear
        width: 100%
        background: $blue
    &._active
      color: $blue
      &:after
        // transition: background .2s, width .3s
        transition-duration: .2s
        background: $blue
        width: 100%

@media(max-width: 769px)
  .t-tabs
    padding: 0 8px
    border-bottom: none
    .t-input
      margin: 0
</style>


// WEBPACK FOOTER //
// src/vue_components/Tabs.vue